<template>
	<form action="" class="scan-box" v-on:submit.prevent="scan">
		
		
		<label for="action" class="scan-box__label">ACTION</label>
		<select id="action" name="action" v-model="action" style='font-size: 30px; margin: 0 auto; text-align: center; width: 300px; display: block;' >
			<option value=""> - Please select - </option>
			<option value="AFT_SUBLIME">AFTER SUBLIME</option>
			<option value="SEWING">SEWING</option>
			<option value="SEWEND">END SEWING</option>
		</select>
		<br>
		<label for="" class="scan-box__label">Scan Barcode</label>
		
		<input
			class="scan-box__input"
			placeholder="Click here and scan a barcode please"
			v-model="item_serial"
			name="item_serial"
			type="text"
			v-on:keyup="scan"
		/>
		<br>
		<input type="checkbox" v-model="printjoblabel" name="printjoblabel" >
		Print Job Label
		
	</form>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default Vue.extend({
	name: "",
	components: {},
	props: ['type'],
	data() {
		return {
			item_serial: "",
			deliveryResp: {}
		};
	},
	methods: {
		async loadZones(){
		
			if (this.action == "") {
				alert("Please selection action first...");
				return;
			}
			
			let data = {
				item_serial: this.item_serial,
				handler: "test",
				process: this.action,
				sessionid: this.$store.getters.sessionid
				
			};
			await this.$store.dispatch('scanRequest', data);
		},
		scan: function(e) {
		if (e.keyCode !== 13) {
			return;
		} 
		e.preventDefault();
		console.log(this.type);
		
		//alert('Enter was pressed');
		
			
			this.loadZones();
			
			//alert('Done');
			if (this.printjoblabel) {
				window.open('backend/print_jobsheet_png.php?itemserial=' + this.item_serial );
			}
			this.item_serial = "";
			this.item_serial.$el.focus();
		
		}
	},
	
  
});
</script>

<style lang="scss" scoped>
.scan-box {
	padding: 20px 0 30px;

	&__label {
		// text-transform: uppercase;
		text-align: center;
		display: block;
		margin-bottom: 10px;
		font-weight: 600;
		font-size: 16px;
	}

	&__input {
		border: 1px solid $border-color;
		border-radius: 5px;
		font-size: 14px;
		display: block;
		margin: 0 auto;
		text-align: center;
		padding: 7px 0;
		width: 300px;
	}
}
</style>